import {AbstractService} from 'services/AbstractService';

const GET_ALL_PLACEMENTS_BIDDER_PERFORMANCE_URL = '/api/seller/performance/bidmanager';
const GET_SUMMARY_BIDDER_PERFORMANCE_URL = '/api/seller/performance/bidmanager/summary';

export class BidderPerformanceSellerService extends AbstractService {
  getAllPlacementsBidderPerformance (params) {
    return this.client.get(GET_ALL_PLACEMENTS_BIDDER_PERFORMANCE_URL, params);
  }

  getSummaryBidderPerformance () {
    return this.client.get(GET_SUMMARY_BIDDER_PERFORMANCE_URL);
  }
}
